(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-experience"] && !Shopify.designMode) return;
  try {
    
  const initCartCarousel = (root = document) => {
    root.querySelectorAll('[data-cart-carousel]').forEach((track) => {
      if (track.dataset.carouselReady === 'true') return;
      track.dataset.carouselReady = 'true';
      const section = track.closest('.cart-experience__products');
      const previous = section?.querySelector('[data-carousel-prev]');
      const next = section?.querySelector('[data-carousel-next]');
      const updateButtons = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .9, 240), behavior: 'smooth' });
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  };

  initCartCarousel();

  document.querySelectorAll('[data-cart-recommendations-url]').forEach((container) => {
    fetch(container.dataset.cartRecommendationsUrl)
      .then((response) => response.text())
      .then((text) => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = text;
        const updated = wrapper.querySelector('#' + container.id);
        if (updated && updated.innerHTML.trim()) {
          container.replaceWith(updated);
          initCartCarousel(document);
        }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srm-shopify-app-redirect"] && !Shopify.designMode) return;
  try {
    
  const redirectRoot = document.querySelector('[data-srm-shopify-redirect]');

  if (redirectRoot) {
    const params = new URLSearchParams(window.location.search);
    const checkoutId = params.get('checkout');
    const isValidCheckoutId = /^\d+$/.test(checkoutId || '');
    const appLink = redirectRoot.querySelector('[data-srm-open-app]');
    const webLink = redirectRoot.querySelector('[data-srm-open-web]');
    const errorMessage = redirectRoot.querySelector('[data-srm-error]');

    if (isValidCheckoutId) {
      const shopifyAppUrl = `shopify://admin/checkouts/${checkoutId}`;
      const shopifyWebUrl = `https://admin.shopify.com/store/santaritasouvenirs/checkouts/${checkoutId}`;
      const launchKey = `srm-shopify-checkout-${checkoutId}`;
      const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      appLink.href = shopifyAppUrl;
      webLink.href = shopifyWebUrl;

      if (isMobileDevice && !window.sessionStorage.getItem(launchKey)) {
        window.sessionStorage.setItem(launchKey, '1');
        window.setTimeout(() => {
          window.location.assign(shopifyAppUrl);
        }, 150);
      }
    } else {
      appLink.hidden = true;
      webLink.hidden = true;
      errorMessage.hidden = false;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
